import { useEffect } from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";

function NotFoundPage() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Page not found — WeddingzVenue";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="not-found-page">
      <div className="not-found-page__bg" aria-hidden="true">
        <span className="not-found-page__orb not-found-page__orb--a" />
        <span className="not-found-page__orb not-found-page__orb--b" />
        <span className="not-found-page__grid" />
      </div>
      <div className="not-found-page__inner">
        <div className="not-found-page__badge" aria-hidden="true">
          Error
        </div>
        <p className="not-found-page__code">404</p>
        <h1 className="not-found-page__title">Page not found</h1>
        <p className="not-found-page__subtitle">
          The page you’re looking for doesn’t exist or may have been moved.
        </p>
        <div className="not-found-page__card">
          <p className="not-found-page__hint">Keep planning your wedding:</p>
          <nav
            className="not-found-page__actions"
            aria-label="Suggested pages"
          >
            <Link
              to="/"
              className="not-found-page__btn not-found-page__btn--primary"
            >
              Back to home
            </Link>
            <Link
              to="/venues"
              className="not-found-page__btn not-found-page__btn--outline"
            >
              Browse venues
            </Link>
            <Link
              to="/vendors"
              className="not-found-page__btn not-found-page__btn--outline"
            >
              Browse vendors
            </Link>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default NotFoundPage;
